import { CircularProgress } from '@mui/material';
type Props = {
    style?: any;
};
const PreLoader = ({ style }: Props) => {
    return (
        <div
            style={{
                justifyContent: 'center',
                flex: 1,
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 2,
                display: 'flex',
                paddingTop: 32,
                ...style,
            }}
        >
            <CircularProgress  size={48} sx={{ color: theme => theme.palette.primary.main }} />
        </div>
    );
};

export default PreLoader;
